export enum ProductDocumentType {
    InspectionCertificate = 'InspectionCertificate',
    StockInspectionCertificate = 'StockInspectionCertificate',
    ServiceCertificate = 'ServiceCertificate',
    StockServiceCertificate = 'StockServiceCertificate',
    SafetyInstruction = 'SafetyInstruction',
    StockSafetyInstruction = 'StockSafetyInstruction',
    ContractInvoices = 'ContractInvoices',
    Invoice = 'Invoice'
}
